<template>
  <a-form-item
    v-if="data"
    :label="data.fieldname"
    class="address"
  >
    <linkage
      :default-value="routes"
      :get-data="getData"
      :search-data="searchData"
      :report-search="reportSearch"
      :has-child="item => item.haschildren !== 0"
      :disabled="data.disabled || clickClear"
      @change="completeHandle"
    >
      <div class="select-box">
        <a-input
          read-only
          :value="codeDesc"
          :placeholder="placeholder"
          :show-search="showSearch"
          :disabled="data.disabled"
          @mouseenter="mouseenterInput"
          @mouseleave="mouseleaveInput"
        />
        <i
          :class="{'iconfont iconicon-test19': !showClear, 'iconfont iconicon-test13-copy fz-14': showClear}"
          @mouseenter="mouseenterInput"
          @mouseleave="mouseleaveInput"
          @click="handleClear"
        />
      </div>
    </linkage>
  </a-form-item>
</template>

<script>
import Linkage from '@/components/pc/Linkage'
import { getArea, SearchArea, addAreaSearchLog } from '@/services/index'

export default {
  name: 'FilterArea',
  components: {
    Linkage
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      routes: [],
      visible: false,
      showClear: false,
      clickClear: false
    }
  },
  computed: {
    codeDesc () {
      return this.routes.map(item => item.name).join(' / ')
    },
    fieldconfig () {
      const { fieldconfig = {} } = this.data
      return fieldconfig
    },
    showSearch () {
      const { showSearch = true } = this.fieldconfig
      return showSearch
    },
    fieldkey () {
      return this.data.fieldkey
    },
    isneeded () {
      return this.data.isneeded === 1
    }
  },
  watch: {
    data: {
      handler (val) {
        this.routes = []
        this.init()
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    init () {
      const { fieldvalue = {} } = this.data
      // const { code = {} } = fieldvalue
      this.routes = Object.keys(fieldvalue).map(key => {
        return {
          code: key,
          name: fieldvalue[key]
        }
      })
    },
    completeHandle (routes) {
      // const { fieldvalue } = this
      this.routes = routes
      // const codes = {}
      // routes.forEach((item) => {
      //   const { code, name } = item
      //   codes[code] = name
      // })
      // fieldvalue.code = codes
      const maps = {}
      routes.forEach(item => {
        maps[item.code] = item.name
      })
      this.$emit('change', maps)
    },

    async getData ({ level, data }) {
      const chain = await getArea()
      const params = {}
      if (data) {
        params.code = data.code
      } else {
        params.fieldkey = this.data.fieldkey
      }
      return new Promise(async (resolve, reject) => {
        await chain
          .params(params)
          .onSuccess(payload => {
            const arr = Object.keys(payload).map(key => payload[key])
            resolve(arr)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    },
    async searchData ({ keyword }) {
      const chain = await SearchArea()
      return new Promise(async (resolve, reject) => {
        await chain
          .params({
            keyword,
            fieldkey: this.data.fieldkey
          })
          .onSuccess(payload => {
            const arr = payload.map(item => {
              return Object.keys(item).map(code => {
                return {
                  code,
                  name: item[code]
                }
              })
            })
            // const arr = Object.keys(payload).map(key => payload[key])
            resolve(arr)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    },
    async reportSearch (value) {
      const chain = await addAreaSearchLog()
      return new Promise(async (resolve, reject) => {
        await chain
          .params({
            name: value
          })
          .onSuccess(payload => {
            resolve(true)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    },
    mouseenterInput () {
      if (this.codeDesc) {
        this.showClear = true
      }
    },
    mouseleaveInput () {
      this.showClear = false
    },
    handleClear () {
      if (this.showClear) {
        // 清除选择的地区数据
        this.routes = []
        this.data.fieldvalue = {}
        this.$emit('change', this.data.fieldvalue)

        // 如果点击清除，禁止下拉出现
        this.clickClear = true
        let timer = null
        clearTimeout(timer)
        timer = setTimeout(() => {
          this.clickClear = false
        }, 60)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.code-line {
  margin-bottom: 24px;
}
.select-box {
  position: relative;
  width: 320px;
  .iconfont {
    position: absolute;
    right: 8px;
    color: $gray3;
  }
}
</style>
<style lang="scss">
.area-pover {
  width: 320px;
  padding-top: 0;
  .ant-popover-arrow {
    display: none;
  }
  .ant-popover-inner-content {
    padding: 0;
  }
}
</style>
